module.exports = __webpack_public_path__ + "img/bp_button_pre_hdgz.6e546ebc.png";